import { Space } from '@procurify/ui'

import { ConfirmationOptionChipStyled } from './styles/ConfirmationOptionChipStyled'
import { type ConversationChoiceOption } from '../../value-objects/ConversationTurnItem'

export interface IConfirmationOptionsProps {
  options: ConversationChoiceOption[]
  disabled?: boolean
  onSelect: (option: ConversationChoiceOption) => void
}

export const ConfirmationOptions = ({
  options,
  disabled = false,
  onSelect,
}: IConfirmationOptionsProps) => {
  if (options.length === 0) {
    return null
  }

  return (
    <Space direction='horizontal' size='small' flexWrap>
      {options.map((option) => (
        <ConfirmationOptionChipStyled
          key={option.value}
          type='button'
          disabled={disabled}
          onClick={() => onSelect(option)}
        >
          {option.label}
        </ConfirmationOptionChipStyled>
      ))}
    </Space>
  )
}
